// Konfiguration eines gespeicherten Berichts (Agent 7A): Zeitraum als Name, Vergleich, Nutzer, Smart View, Kennzahlen und seitenspezifische
// Zusätze (Pipeline, Richtung …) liegen flach in `konfiguration` (API.md 22.1).
import type { Vergleich } from "../api/berichte";
import type { FilterWerte } from "./zustand";
import { wahlAus, type ZeitraumWahl } from "./zeitraum";

export type Konfig = Record<string, unknown>;

export function konfigAusFilter(w: FilterWerte, zusatz: Konfig = {}): Konfig {
  const z: ZeitraumWahl = w.wahl;
  return {
    zeitraum: z.art === "eigen" ? { art: "eigen", von: z.von, bis: z.bis } : { art: z.art },
    vergleich: w.vergleich,
    nutzer_ids: w.nutzerIds,
    smart_view_id: w.smartViewId,
    ...zusatz,
  };
}

/** Filterfelder aus einer gespeicherten Konfiguration (fehlende Angaben: Standard). */
export function filterAusKonfig(k: Konfig): Pick<FilterWerte, "wahl" | "vergleich" | "nutzerIds" | "smartViewId"> {
  const v = k.vergleich;
  return {
    wahl: wahlAus(k.zeitraum, { art: "diese_woche" }),
    vergleich: v === "vorperiode" || v === "vorjahr" ? (v as Vergleich) : null,
    nutzerIds: Array.isArray(k.nutzer_ids) ? k.nutzer_ids.filter((x): x is string => typeof x === "string") : [],
    smartViewId: typeof k.smart_view_id === "string" && k.smart_view_id ? k.smart_view_id : null,
  };
}

function sortiert(x: unknown): unknown {
  if (Array.isArray(x)) return x.map(sortiert);
  if (x && typeof x === "object") {
    return Object.fromEntries(
      Object.entries(x as Konfig)
        .filter(([, v]) => v !== undefined)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([k, v]) => [k, sortiert(v)]),
    );
  }
  return x;
}

/** Vergleichbare Form: Standardwerte ergänzt, Schlüssel geordnet. */
export function normiert(k: Konfig): string {
  const f = filterAusKonfig(k);
  const rest: Konfig = { ...k };
  for (const s of ["zeitraum", "vergleich", "nutzer_ids", "smart_view_id"]) delete rest[s];
  return JSON.stringify(sortiert({ ...konfigAusFilter({ ...f, berichtId: null }), ...rest }));
}

export const kennzahlenAus = (k: Konfig): string[] =>
  Array.isArray(k.kennzahlen) ? k.kennzahlen.filter((x): x is string => typeof x === "string") : [];
